// extracted by mini-css-extract-plugin
export default {"container":"EditCard_container__SiOch","subContainer":"EditCard_subContainer__PqbX0","leftArrow":"EditCard_leftArrow__tEsHe"};